import { Logo } from "@/components/ui/Logo";
import { cn } from "@/lib/cn";
import styles from "./ProtectedRoute.module.css";

/** Fallback do Suspense enquanto o chunk de uma rota lazy carrega. */
export function PageFallback() {
  return (
    <div className={styles.loading}>
      <Logo size={52} className={styles.mark} />
      <span className={cn(styles.spinner, "loading-spin")} aria-hidden />
    </div>
  );
}
